import { KeyLabel, MOD } from './KeyLabel';
export const KeyLabelNorman: KeyLabel[] = [
  {
    code: 4,
    label: 'A',
  },
  {
    code: 5,
    label: 'B',
  },
  {
    code: 6,
    label: 'C',
  },
  {
    code: 7,
    label: 'E',
  },
  {
    code: 8,
    label: 'D',
  },
  {
    code: 9,
    label: 'T',
  },
  {
    code: 10,
    label: 'G',
  },
  {
    code: 11,
    label: 'Y',
  },
  {
    code: 12,
    label: 'R',
  },
  {
    code: 13,
    label: 'N',
  },
  {
    code: 14,
    label: 'I',
  },
  {
    code: 15,
    label: 'O',
  },
  {
    code: 16,
    label: 'M',
  },
  {
    code: 17,
    label: 'P',
  },
  {
    code: 18,
    label: 'L',
  },
  {
    code: 19,
    label: ';',
    meta: [
      {
        label: ':',
        modifiers: MOD.SFT,
      },
      {
        label: ':',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
    ],
  },
  {
    code: 20,
    label: 'Q',
  },
  {
    code: 21,
    label: 'F',
  },
  {
    code: 22,
    label: 'S',
  },
  {
    code: 23,
    label: 'K',
  },
  {
    code: 24,
    label: 'U',
  },
  {
    code: 25,
    label: 'V',
  },
  {
    code: 26,
    label: 'W',
  },
  {
    code: 27,
    label: 'X',
  },
  {
    code: 28,
    label: 'J',
  },
  {
    code: 29,
    label: 'Z',
  },
  {
    code: 30,
    label: '1',
    meta: [
      {
        label: '!',
        modifiers: MOD.SFT,
      },
      {
        label: '!',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
    ],
  },
  {
    code: 31,
    label: '2',
    meta: [
      {
        label: '@',
        modifiers: MOD.SFT,
      },
      {
        label: '@',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
    ],
  },
  {
    code: 32,
    label: '3',
    meta: [
      {
        label: '#',
        modifiers: MOD.SFT,
      },
      {
        label: '#',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
    ],
  },
  {
    code: 33,
    label: '4',
    meta: [
      {
        label: '$',
        modifiers: MOD.SFT,
      },
      {
        label: '$',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
    ],
  },
  {
    code: 34,
    label: '5',
    meta: [
      {
        label: '%',
        modifiers: MOD.SFT,
      },
      {
        label: '%',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
    ],
  },
  {
    code: 35,
    label: '6',
    meta: [
      {
        label: '^',
        modifiers: MOD.SFT,
      },
      {
        label: '^',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
    ],
  },
  {
    code: 36,
    label: '7',
    meta: [
      {
        label: '&',
        modifiers: MOD.SFT,
      },
      {
        label: '&',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
    ],
  },
  {
    code: 37,
    label: '8',
    meta: [
      {
        label: '*',
        modifiers: MOD.SFT,
      },
      {
        label: '*',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
    ],
  },
  {
    code: 38,
    label: '9',
    meta: [
      {
        label: '(',
        modifiers: MOD.SFT,
      },
      {
        label: '(',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
    ],
  },
  {
    code: 39,
    label: '0',
    meta: [
      {
        label: ')',
        modifiers: MOD.SFT,
      },
      {
        label: ')',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
    ],
  },
  {
    code: 45,
    label: '-',
    meta: [
      {
        label: '_',
        modifiers: MOD.SFT,
      },
      {
        label: '_',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
    ],
  },
  {
    code: 46,
    label: '=',
    meta: [
      {
        label: '+',
        modifiers: MOD.SFT,
      },
      {
        label: '+',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
    ],
  },
  {
    code: 47,
    label: '[',
    meta: [
      {
        label: '{',
        modifiers: MOD.SFT,
      },
      {
        label: '{',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
    ],
  },
  {
    code: 48,
    label: ']',
    meta: [
      {
        label: '}',
        modifiers: MOD.SFT,
      },
      {
        label: '}',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
    ],
  },
  {
    code: 49,
    label: '(backslash)',
    meta: [
      {
        label: '|',
        modifiers: MOD.SFT,
      },
      {
        label: '|',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
    ],
  },
  {
    code: 51,
    label: 'H',
  },
  {
    code: 52,
    label: "'",
    meta: [
      {
        label: '"',
        modifiers: MOD.SFT,
      },
      {
        label: '"',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
    ],
  },
  {
    code: 53,
    label: '`',
    meta: [
      {
        label: '~',
        modifiers: MOD.SFT,
      },
      {
        label: '~',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
    ],
  },
  {
    code: 54,
    label: ',',
    meta: [
      {
        label: '<',
        modifiers: MOD.SFT,
      },
      {
        label: '<',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
    ],
  },
  {
    code: 55,
    label: '.',
    meta: [
      {
        label: '>',
        modifiers: MOD.SFT,
      },
      {
        label: '>',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
    ],
  },
  {
    code: 56,
    label: '/',
    meta: [
      {
        label: '?',
        modifiers: MOD.SFT,
      },
      {
        label: '?',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
    ],
  },
  {
    code: 531,
    label: ':',
  },
  {
    code: 542,
    label: '!',
  },
  {
    code: 543,
    label: '@',
  },
  {
    code: 544,
    label: '#',
  },
  {
    code: 545,
    label: '$',
  },
  {
    code: 546,
    label: '%',
  },
  {
    code: 547,
    label: '^',
  },
  {
    code: 548,
    label: '&',
  },
  {
    code: 549,
    label: '*',
  },
  {
    code: 550,
    label: '(',
  },
  {
    code: 551,
    label: ')',
  },
  {
    code: 557,
    label: '_',
  },
  {
    code: 558,
    label: '+',
  },
  {
    code: 559,
    label: '{',
  },
  {
    code: 560,
    label: '}',
  },
  {
    code: 561,
    label: '|',
  },
  {
    code: 564,
    label: '"',
  },
  {
    code: 565,
    label: '~',
  },
  {
    code: 566,
    label: '<',
  },
  {
    code: 567,
    label: '>',
  },
  {
    code: 568,
    label: '?',
  },
  {
    code: 4627,
    label: ':',
  },
  {
    code: 4638,
    label: '!',
  },
  {
    code: 4639,
    label: '@',
  },
  {
    code: 4640,
    label: '#',
  },
  {
    code: 4641,
    label: '$',
  },
  {
    code: 4642,
    label: '%',
  },
  {
    code: 4643,
    label: '^',
  },
  {
    code: 4644,
    label: '&',
  },
  {
    code: 4645,
    label: '*',
  },
  {
    code: 4646,
    label: '(',
  },
  {
    code: 4647,
    label: ')',
  },
  {
    code: 4653,
    label: '_',
  },
  {
    code: 4654,
    label: '+',
  },
  {
    code: 4655,
    label: '{',
  },
  {
    code: 4656,
    label: '}',
  },
  {
    code: 4657,
    label: '|',
  },
  {
    code: 4660,
    label: '"',
  },
  {
    code: 4661,
    label: '~',
  },
  {
    code: 4662,
    label: '<',
  },
  {
    code: 4663,
    label: '>',
  },
  {
    code: 4664,
    label: '?',
  },
];
